import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { Size, Spacing } from '~/types/ThemeTypes'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'
import { PhoneComponentSizes } from './Constants'

const { Icon: DefaultIconColor } = themeColorSectionKeys.defaults
const { CallControl: CallControlColors } = phoneColorKeys.Phone
const {
  CallControl: {
    Bar: { padding: BarPadding },
  },
} = PhoneComponentSizes

const callControlParts = [
  'bar',
  'drawer',
  'drawerHeader',
  'drawerHeaderText',
  'drawerHeaderIconButton',
  'drawerHeaderIcon',
  'icon',
  'tooltip',
] as const

const helpers = createMultiStyleConfigHelpers(callControlParts)

export const CallControlStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    bar: {
      bg: CallControlColors.ControlBar.Background,
      width: 'fit-content',
      gap: Spacing._4,
      borderRadius: 'full',
      border: '2px solid',
      borderColor: CallControlColors.ControlBar.Border,
    },
    drawer: {
      bg: CallControlColors.ControlDrawer.Background,
      height: 'fit-content',
      marginBottom: '-1px',
      paddingX: Spacing._5,
      paddingTop: Spacing._3,
      borderTopRadius: '12px',
      border: '2px solid',
      borderColor: CallControlColors.ControlDrawer.Border,
    },
    drawerHeader: {
      height: '40px',
      width: 'full',
      paddingY: '8px',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '8px',
    },
    drawerHeaderText: {
      ...textStyles[textStyleKeys.Body2_Bold],
    },
    drawerHeaderIconButton: {
      marginRight: '-10px',
    },
    drawerHeaderIcon: {
      boxSize: '30px',
      color: DefaultIconColor,
      _hover: {
        background: 'transparent',
      },
    },
    icon: {
      color: DefaultIconColor,
      boxSize: '40px',
    },
    tooltip: {},
  },
  sizes: {
    [Size.sm]: {
      bar: {
        padding: BarPadding.sm.px,
      },
      drawer: {
        width: '380px',
      },
      icon: {},
    },
    [Size.md]: {
      bar: {
        padding: BarPadding.md.px,
      },
      drawer: {
        width: '380px',
      },
      icon: {},
    },
    [Size.lg]: {
      bar: {
        padding: BarPadding.lg.px,
      },
      drawer: {
        width: '460px',
      },
      icon: {},
    },
    [Size.xl]: {
      bar: {
        padding: BarPadding.xl.px,
      },
      drawer: {
        width: '624px',
      },
    },
  },
})

export const useCallControlStyle = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ CallControlStyle }),
    props,
  ) as MultiStyleType<typeof callControlParts>
}
